import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

import type { SourcedocumentDataSchemaFor } from "./_gmw-event-schema-collection";

export const gmwShorteningSchema: SourcedocumentDataSchemaFor<"GMW_Shortening"> = {
  type: "object",
  title: "Gebeurtenis gegevens",
  required: ["eventDate", "monitoringTubes"],
  properties: {
    ...pickGmwLibraryFields(["eventDate", "wellHeadProtector"]),
    monitoringTubes: {
      type: "array",
      title: "Monitoringsbuis",
      minItems: 1,
      items: {
        type: "object",
        required: [
          "tubeNumber",
          "tubeTopPosition",
          "tubeTopPositioningMethod",
          "plainTubePartLength",
        ],
        properties: pickGmwLibraryFields([
          "tubeNumber",
          "tubeTopPosition",
          "tubeTopPositioningMethod",
          "plainTubePartLength",
        ]),
      },
    },
  },
};
